const malwareData1 = [
    {
        id: 1,
        threat_name: 'Trojanscript',
        file_name: 'Evgeny_CV_m.pdf',
        file_size: 129000,
        file_type: 'pdf',
        classification: 'Trojan',
        severity: 20,
        md5: 'c0d5b1cc0c77fcf32ff02aac98fac536',
        sha1: '2154845e38fc348ae1be419684f9572a680fabfd',
        sha256: 'e68f38195b3c816309882388c23118327ec97f9ad775bf59b9a8a3089dd68fd8',
        dst: '192.168.13.178',
    },
    {
        id: 2,
        threat_name: 'Trojan:Win32',
        file_name: '0db5e5b68dc4b8089197de9c1e345056f45c006b7b487f7d8d',
        file_size: 97321,
        file_type: 'exe',
        classification: 'Trojan',
        severity: 40,
        md5: '16bb9def4fabfa2ccb3efc1ca5bfc2fa',
        sha1: '-',
        sha256: '0db5e5b68dc4b8089197de9c1e345056f45c006b7b487f7d8d57b49ae385bad0',
        dst: '10.13.23.44',
    },
    {
        id: 3,
        threat_name: 'TrojanDownloader/Emotet.SCKIMT',
        file_name: 'UNTITLED-463860 436.doc',
        file_size: 198709,
        file_type: 'doc',
        classification: 'Trojan',
        severity: 35,
        md5: 'd6774c59aafa609caddd4c637d63281b',
        sha1: '9084845e38fc348ae1be419684f9572a680f9ksoi75',
        sha256: 'dcc3ee11da81996e905f2f00e24483150c0c38eebcfa3d3a8019a6ba1a098b34',
        dst: '194.29.36.43',
    },
    {
        id: 4,
        threat_name: 'JS:Adware.Popunder.V',
        file_name: '3702bac845b3f51159f301ee13642f76.js',
        file_size: 24509,
        file_type: 'text/html',
        classification: 'Adware',
        severity: 70,
        md5: '59b012198cbbbd7d4d0fe44bb2efada0',
        sha1: '9075635e38fc348ae28ui7y9684f9572a680f4y7',
        sha256: '14e966ad882c0aff9d0eb6e221af4946ab315a84d5f6f735cae1b8fe92c07e06',
        dst: '172.23.84.93',
    },
    {
        id: 5,
        threat_name: 'Backdoor:Win32/Flyin.ski.A',
        file_name: 'F395143E3AC4BDA37E026E7C8A6E06E8',
        file_size: 705890,
        file_type: 'exe',
        classification: 'Backdoor',
        severity: 60,
        md5: 'f395143e3ac4bda37e026e7c8a6e06e8',
        sha1: '9087645e38fc34io9pbe419684f9572a680lo908k1',
        sha256: 'd43560277c7cc53db745491183496aa20ae9a86af58535be6ca0dde87e7e9c41',
        dst: '194.29.36.43',
    },
];

const malwareData2 = [
    {
        id: 1,
        threat_name: 'Trojanscript',
        file_name: 'Evgeny_CV_m.pdf',
        file_size: 129000,
        file_type: 'pdf',
        classification: 'Trojan',
        severity: 20,
        md5: 'c0d5b1cc0c77fcf32ff02aac98fac536',
        sha1: '2154845e38fc348ae1be419684f9572a680fabfd',
        sha256: 'e68f38195b3c816309882388c23118327ec97f9ad775bf59b9a8a3089dd68fd8',
        dst: '192.168.13.178',
    },
    {
        id: 2,
        threat_name: 'Trojan:Win32',
        file_name: '0db5e5b68dc4b8089197de9c1e345056f45c006b7b487f7d8d',
        file_size: 97321,
        file_type: 'exe',
        classification: 'Trojan',
        severity: 40,
        md5: '16bb9def4fabfa2ccb3efc1ca5bfc2fa',
        sha1: '-',
        sha256: '0db5e5b68dc4b8089197de9c1e345056f45c006b7b487f7d8d57b49ae385bad0',
        dst: '10.13.23.44',
    },
    {
        id: 3,
        threat_name: 'TrojanDownloader/Emotet.SCKIMT',
        file_name: 'UNTITLED-463860 436.doc',
        file_size: 198709,
        file_type: 'doc',
        classification: 'Trojan',
        severity: 35,
        md5: 'd6774c59aafa609caddd4c637d63281b',
        sha1: '9084845e38fc348ae1be419684f9572a680f9ksoi75',
        sha256: 'dcc3ee11da81996e905f2f00e24483150c0c38eebcfa3d3a8019a6ba1a098b34',
        dst: '194.29.36.43',
    },
    {
        id: 4,
        threat_name: 'JS:Adware.Popunder.V',
        file_name: '3702bac845b3f51159f301ee13642f76.js',
        file_size: 24509,
        file_type: 'text/html',
        classification: 'Adware',
        severity: 70,
        md5: '59b012198cbbbd7d4d0fe44bb2efada0',
        sha1: '9075635e38fc348ae28ui7y9684f9572a680f4y7',
        sha256: '14e966ad882c0aff9d0eb6e221af4946ab315a84d5f6f735cae1b8fe92c07e06',
        dst: '172.23.84.93',
    },
    {
        id: 5,
        threat_name: 'Backdoor:Win32/Flyin.ski.A',
        file_name: 'F395143E3AC4BDA37E026E7C8A6E06E8',
        file_size: 705890,
        file_type: 'exe',
        classification: 'Backdoor',
        severity: 60,
        md5: 'f395143e3ac4bda37e026e7c8a6e06e8',
        sha1: '9087645e38fc34io9pbe419684f9572a680lo908k1',
        sha256: 'd43560277c7cc53db745491183496aa20ae9a86af58535be6ca0dde87e7e9c41',
        dst: '194.29.36.43',
    },
];

export { malwareData1, malwareData2 };